<mat-card>
  <mat-card-content>
    <mat-card-title>
      Gestisci ricevute
    </mat-card-title>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>

    <div fxLayout="row wrap">
      <div fxFlex.gt-sm="50%">
        <mat-form-field class="full-width">
          <input matInput
                 placeholder="Filtra"
                 [(ngModel)]="txtFiltra"
                 id="txtFiltra"
                 value=""
                 (keyup)='updateFilter($event)'>
        </mat-form-field>
      </div>
    </div>

    <ngx-datatable #grdGestisciRicevute
                   [rows]="lstElenco"
                   [columnMode]="'flex'"
                   [headerHeight]="50"
                   [footerHeight]="50"
                   [limit]="30"
                   [rowHeight]="'auto'">

      <ngx-datatable-column name="" [flexGrow]="0.5">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div style="float:left">
            <button mat-icon-button mat-sm-button color="primary"
                    class="mr-1"
                    (click)="btnConfermaPagamento()"
                    matTooltip="Conferma pagamento">
              <mat-icon>done_all</mat-icon>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="" [flexGrow]="0.5">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div style="float:left">
            <button mat-icon-button mat-sm-button color="primary"
                    class="mr-1"
                    (click)="btnGeneraRicevuta()"
                    matTooltip="Genera ricevuta">
              <mat-icon>receipt</mat-icon>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Cognome Nome"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="DescrizioneTipologiaRichiesta">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Cognome }}  {{ row?.Nome }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Tipologia"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="DescrizioneTipologiaRichiesta">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.DescrizioneTipologiaRichiesta }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Note bonifico"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="NoteBonifico">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.NoteBonifico}}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Pagamento"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Descrizione">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Descrizione }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Stato"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="DescrizioneStatoApprovazione ">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.DescrizioneStatoApprovazione }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Pdf"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Pdf">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span *ngIf="idFattura > 0">
            <mat-icon>picture_as_pdf</mat-icon>
          </span>
        </ng-template>
      </ngx-datatable-column>

    </ngx-datatable>

  </mat-card-content>
</mat-card>
